import {
    // FILE_UPLOAD,
    CREATE_ARCHITECTURESERVERVISITS,
    RETRIEVE_ARCHITECTURESERVERVISITS,
    RETRIEVE_ARCHITECTURESERVERACTIVITIES,
    RETRIEVE_ARCHITECTURESERVERRECOMMENDEMPLOYEE,
    RETRIEVESINGLE_ARCHITECTURESERVERVISITS,
    UPDATE_ARCHITECTURESERVERVISITS,
    DELETE_ARCHITECTURESERVERVISITS,
} from "./type";
import ARCServerVisits from "../service/arcServerVisits";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await ARCServerVisits.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await ARCServerVisits.create(data);
        dispatch({
            type: CREATE_ARCHITECTURESERVERVISITS,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await ARCServerVisits.fetchList(data);
        dispatch({
            type: RETRIEVE_ARCHITECTURESERVERVISITS,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveActivityList = (data) => async (dispatch) => {
    try {
        const res = await ARCServerVisits.fetchActivityList(data);
        dispatch({
            type: RETRIEVE_ARCHITECTURESERVERACTIVITIES,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveRecommandEmployeeList = (data) => async (dispatch) => {
    try {
        const res = await ARCServerVisits.fetchRecommendEmployeeList(data);
        // dispatch({
        //     type: RETRIEVE_ARCHITECTURESERVERRECOMMENDEMPLOYEE,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await ARCServerVisits.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_ARCHITECTURESERVERVISITS,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await ARCServerVisits.update(data);
        dispatch({
            type: UPDATE_ARCHITECTURESERVERVISITS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await ARCServerVisits.changeStatus(data);
//         dispatch({
//             type: UPDATE_ARCHITECTURESERVERVISITS,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await ARCServerVisits.trash(data);
        dispatch({
            type: DELETE_ARCHITECTURESERVERVISITS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};